'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "icon", "_useNativeButton"];
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import { getBlueOceanGradient } from '../../color/gradients/Styles';
import BeakerIcon from './BeakerIcon';
import UIFloatingActionButton from '../UIFloatingActionButton';
import { CALYPSO_DARK, OLAF } from 'HubStyleTokens/colors';
import HoverProvider from '../../providers/HoverProvider';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const hoveredStyles = css(["color:", ";background-color:", ";"], OLAF, CALYPSO_DARK);
const BetaTheme = styled(UIFloatingActionButton).withConfig({
  displayName: "UIBetaButton__BetaTheme",
  componentId: "c11xp5-0"
})(["", ""], props => props.hovered ? hoveredStyles : getBlueOceanGradient);
const StyledBeakerIcon = styled(BeakerIcon).withConfig({
  displayName: "UIBetaButton__StyledBeakerIcon",
  componentId: "c11xp5-1"
})(["height:54px;left:0;position:absolute;top:-24px;width:20px;"]);
const Inner = styled.span.withConfig({
  displayName: "UIBetaButton__Inner",
  componentId: "c11xp5-2"
})(["padding-left:", ";position:relative;"], props => props.icon === 'beaker' ? '26px' : 0);
const UIBetaButton = props => {
  const {
      children,
      icon
      // No-op prop received when used as a UIDropdown button
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(HoverProvider, Object.assign({}, props, {
    children: hoverProviderProps => /*#__PURE__*/_jsx(BetaTheme, Object.assign({}, rest, hoverProviderProps, {
      children: /*#__PURE__*/_jsxs(Inner, {
        icon: icon,
        children: [icon === 'beaker' ? /*#__PURE__*/_jsx(StyledBeakerIcon, {}) : null, children]
      })
    }))
  }));
};
UIBetaButton.propTypes = Object.assign({}, UIFloatingActionButton.propTypes, {
  icon: PropTypes.oneOf(['beaker', 'none'])
});
UIBetaButton.defaultProps = Object.assign({}, UIFloatingActionButton.defaultProps, {
  icon: 'beaker'
});
UIBetaButton.displayName = 'UIBetaButton';
export default UIBetaButton;